export const START_CLASS_1 = "Start Class 1";
export const RESUME_PROGRAM = "Resume Program";

// BREAKPOINTS
export const LARGE_CUSTOM_BREAKPOINT = "1450px";
